import { Route, Switch } from "wouter";
import { AuthProvider } from "@/contexts/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import AccountDeleted from "@/pages/AccountDeleted";
import Claim from "@/pages/Claim";
import Home from "@/pages/Home";
import Library from "@/pages/Library";
import Login from "@/pages/Login";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import SharePage from "@/pages/SharePage";
import Terms from "@/pages/Terms";
import VoicePage from "@/pages/VoicePage";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/auth/callback" component={AuthCallback} />
      <Route path="/account-deleted" component={AccountDeleted} />
      <Route path="/privacy" component={Privacy} />
      <Route path="/terms" component={Terms} />
      <Route path="/claim" component={Claim} />
      <Route path="/library" component={Library} />
      <Route path="/s/:token" component={SharePage} />
      <Route path="/v/:page" component={VoicePage} />
      <Route component={NotFound} />
    </Switch>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}
